/** Claves guardadas en Firestore / API (estables). Etiquetas en español solo para UI y texto al cliente. */
export const WEEKDAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const WEEKDAY_LABELS = {
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
};

export function createDefaultWeeklySchedule() {
  return Object.fromEntries(
    WEEKDAY_KEYS.map((k) => [k, { open: true, open_time: '', close_time: '' }])
  );
}

/** Mezcla datos del servidor con plantilla completa (7 días). */
export function mergeWeeklyFromApi(raw) {
  const base = createDefaultWeeklySchedule();
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return base;
  for (const k of WEEKDAY_KEYS) {
    const d = raw[k];
    if (d && typeof d === 'object') {
      base[k] = {
        open: d.open !== false,
        open_time: String(d.open_time ?? '').trim().slice(0, 5),
        close_time: String(d.close_time ?? '').trim().slice(0, 5),
      };
    }
  }
  return base;
}

/** Hay al menos un día con cierre explícito o con ambas horas. */
export function weeklyScheduleIsConfigured(ws) {
  if (!ws || typeof ws !== 'object' || Array.isArray(ws)) return false;
  return WEEKDAY_KEYS.some((key) => {
    const d = ws[key];
    if (!d || typeof d !== 'object') return false;
    if (d.open === false) return true;
    const ot = String(d.open_time || '').trim();
    const ct = String(d.close_time || '').trim();
    return Boolean(ot && ct);
  });
}

/** Texto multilínea para asistente / menú; null si no aplica. */
export function formatWeeklyScheduleCustomerText(ws) {
  if (!weeklyScheduleIsConfigured(ws)) return null;
  return WEEKDAY_KEYS.map((key) => {
    const label = WEEKDAY_LABELS[key];
    const d = ws[key] || {};
    if (d.open === false) return `${label}: Cerrado`;
    const ot = String(d.open_time || '').trim();
    const ct = String(d.close_time || '').trim();
    if (ot && ct) return `${label}: de ${ot} a ${ct}`;
    return `${label}: horario por confirmar`;
  }).join('\n');
}

/** Prioriza horario por día si está configurado; si no, `schedule` en texto libre. */
export function formatScheduleForCustomer(business) {
  const fromWeekly = formatWeeklyScheduleCustomerText(business?.weekly_schedule);
  if (fromWeekly) return fromWeekly;
  return String(business?.schedule || '').trim();
}
